import { render, staticRenderFns } from "./ServiceRequestAgeCount.vue?vue&type=template&id=23b50653&scoped=true&"
import script from "./ServiceRequestAgeCount.vue?vue&type=script&lang=js&"
export * from "./ServiceRequestAgeCount.vue?vue&type=script&lang=js&"
import style0 from "./ServiceRequestAgeCount.vue?vue&type=style&index=0&id=23b50653&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b50653",
  null
  
)

export default component.exports